"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rollingScheduleGenerator = exports.getCurrentAndNextScheduledInfo = exports.evaluateRollingSchedule = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const lambda_1 = require("../../../util/lambda");
const helpers_1 = require("../../../util/time/helpers");
/** 2025 03 NOTE: DELAY ACTUALLY OCCURS BEFORE OPERATION. THIS IS NOT DOCUMENENTED CURRENTLY IN DEVICE FIRMWARE SPEC */
const debug = lambda_1.DEBUG_OVERRIDE || (lambda_1.NOT_LAMBDA && true);
const isReasonableTimestamp = (0, helpers_1.getReasonableTimestampMsFilter)(10, 10);
const evaluateRollingSchedule = ({ rollingPatternConfig }) => {
    let res = { matchedNow: null, matchedNext: null };
    const relativeDate = new Date();
    const { startTimeUtcSeconds, delay, duration, enabled } = rollingPatternConfig;
    /** TAG: ROLLING PROGRAMME ENABLED PROVISION */
    const isEnabled = enabled === 1;
    const scheduleStartMs = startTimeUtcSeconds * iotv_v3_types_1.Milliseconds.SECOND;
    if (isReasonableTimestamp(scheduleStartMs)) {
        const validSchduleOutput = (0, exports.getCurrentAndNextScheduledInfo)({ relativeDate, rollingPatternConfig });
        if (validSchduleOutput) {
            const { cycleTimeMs, durationMs, isInDelayPhase, isInEffect, isInOperationPhase, lastScheduledStartMs, nextScheduledStartMs } = validSchduleOutput;
            const isMatchedNow = !!(lastScheduledStartMs && isEnabled) && lastScheduledStartMs + durationMs > relativeDate.valueOf();
            const matchedNow = isMatchedNow
                ? { enabled: isEnabled, dateRange: [new Date(lastScheduledStartMs), new Date(lastScheduledStartMs + durationMs)] }
                : null;
            const matchedNext = isEnabled
                ? { enabled: isEnabled, dateRange: [new Date(nextScheduledStartMs), new Date(nextScheduledStartMs + durationMs)] }
                : null;
            res = { matchedNext, matchedNow };
        }
    }
    else {
        debug && console.log(`WARN: ${scheduleStartMs} is not a reasonable timestamp in ms, not evaluating as validation will throw`);
    }
    return res;
};
exports.evaluateRollingSchedule = evaluateRollingSchedule;
/**
 * @returns most recent and next rolling schedule based on relative date
 * @throws Error if data is not reasonable
 */
const getCurrentAndNextScheduledInfo = ({ relativeDate, rollingPatternConfig }) => {
    const { startTimeUtcSeconds, delay, duration } = rollingPatternConfig;
    const delayMs = delay * iotv_v3_types_1.Milliseconds.MINUTE;
    const durationMs = duration * iotv_v3_types_1.Milliseconds.MINUTE;
    const cycleTimeMs = delayMs + durationMs;
    const scheduleStartMs = startTimeUtcSeconds * iotv_v3_types_1.Milliseconds.SECOND;
    if (!isReasonableTimestamp(scheduleStartMs))
        throw new Error(`${scheduleStartMs} is not a reasonable timestamp in ms`);
    const relativeTimeMs = relativeDate.valueOf();
    const isInEffect = relativeTimeMs > scheduleStartMs;
    // conditions for not isInEffect
    let lastCycleStartMs = null;
    let lastScheduledStartMs = null;
    let nextCycleStartMs = scheduleStartMs + durationMs;
    let nextScheduledStartMs = scheduleStartMs;
    let isInDelayPhase = false;
    let isInOperationPhase = false;
    if (isInEffect) {
        const timeSinceStart = relativeTimeMs - scheduleStartMs;
        const timeSinceLastActive = timeSinceStart & cycleTimeMs;
        const pastCycles = Math.floor(timeSinceStart / cycleTimeMs);
        lastScheduledStartMs = scheduleStartMs + pastCycles * cycleTimeMs;
        lastCycleStartMs = lastScheduledStartMs + durationMs;
        nextCycleStartMs = lastScheduledStartMs + cycleTimeMs;
        nextScheduledStartMs = lastCycleStartMs + cycleTimeMs;
        // is it currently waiting for a programme
        isInOperationPhase = timeSinceLastActive < durationMs;
        isInDelayPhase = !!!isInOperationPhase;
    }
    let res = null;
    if (rollingPatternConfig.delay === 0 || rollingPatternConfig.duration === 0) {
    }
    else {
        res = {
            lastCycleStartMs, // last finish time
            lastScheduledStartMs, // last start time
            nextCycleStartMs, // next `finish`
            nextScheduledStartMs, // next start time
            isInEffect, // above start time
            isInDelayPhase, // in waiting
            isInOperationPhase, // in active
            durationMs, // calculated
            cycleTimeMs, // calculated
        };
    }
    return res;
};
exports.getCurrentAndNextScheduledInfo = getCurrentAndNextScheduledInfo;
const rollingScheduleGenerator = function* ({ startDate, endDate, rollingPatternConfig }) {
    const validSchduleOutput = (0, exports.getCurrentAndNextScheduledInfo)({ relativeDate: startDate, rollingPatternConfig });
    if (validSchduleOutput) {
        const { nextScheduledStartMs, durationMs, cycleTimeMs } = validSchduleOutput;
        let currentStartMs = nextScheduledStartMs;
        const endMs = endDate.valueOf();
        /** TAG - DISABLED ROLLING PROGRAMME PROVISION */
        do {
            const dateRange = [new Date(currentStartMs), new Date(currentStartMs + durationMs)];
            yield dateRange;
            currentStartMs += cycleTimeMs;
        } while (currentStartMs <= endMs);
    }
    else {
        console.log(`NO SCHEDULES TO GENERATE AS  getCurrentAndNextScheduledInfo gave null return`);
    }
    return 'done';
};
exports.rollingScheduleGenerator = rollingScheduleGenerator;
